<div class="game-box-toolbar" *ngIf="showGameBox$ | async">
    <ng-container *ngFor="let game of gamesList$ | async">
        @if(game.componentType === 'game') {
            @if(!game.toNav) {
                <app-tab-box
                    [inAppGameBox]="true"
                    class="tab-box clickable game-box-toolbar-inner"
                    [ngClass]="{selected: (selectedGame$ | async) === game.gameStateId }"
                    [tableID] = "game.tableId"
                    [gameStateId] = "game.gameStateId"
                    [clubId]="game.clubId"
                    [tableType] = "game.type"
                    [tournamentId] = "game.tournamentId"
                    (click)="gameClicked(game)">
                </app-tab-box>
            }
        }
        <div
            *ngIf="game.componentType === 'stream'"
            class="tab-box clickable game-box-toolbar-inner"
            [ngClass]="{selected: (selectedGame$ | async) === game.gameStateId }"
            (click)="gameClicked(game)"
        >
            <img class="non-game" src="assets/icon/add-page/stream_tab.webp" alt="">
        </div>
        <div
            *ngIf="game.componentType === 'clubChat'"
            class="tab-box clickable game-box-toolbar-inner"
            [ngClass]="{selected: (selectedGame$ | async) === game.gameStateId }"
            (click)="gameClicked(game)"
        >
            <img class="non-game" src="assets/icon/add-page/club_chat_tab.webp" alt="chat icon">
        </div>
    </ng-container>
</div>
